import React from "react"
import PropTypes from "prop-types"
import { Button, Drawer, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { Icon } from "ui/Icon"
import styles from "./WidgetSheet.module.css"

// The widget's sheet on smaller screens (Figma 6058:140316): from the bottom with a handle on a
// phone, from the right on a tablet. A title with an X, a scrolling body and a fixed footer.
// ui/Drawer's CustomDrawer has no footer and its global styles cap every bottom drawer's body at
// 70vh with 20px padding, so the widget keeps its own.
const WidgetSheet = ({ isOpen, onClose, title, footer, placement, width, children }) => {
  const { t } = useTranslation()
  const isBottom = placement === "bottom"

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      placement={placement}
      width={isBottom ? undefined : width}
      height={isBottom ? "auto" : undefined}
      closable={false}
      rootClassName={`${styles.sheet} ${isBottom ? styles.bottom : styles.side}`}
      title={
        <Flex vertical>
          {isBottom && <span className={styles.handle} aria-hidden="true" />}
          <Flex align="center" justify="space-between" gap={16} className={styles.titleRow}>
            <span className={styles.title}>{title}</span>
            <Button
              type="text"
              shape="circle"
              className={styles.closeButton}
              aria-label={t("booking_widget.sheet.close")}
              onClick={onClose}
              icon={<Icon type="feather" name="X" width={24} height={24} color="currentColor" />}
            />
          </Flex>
        </Flex>
      }
      footer={footer}
    >
      {children}
    </Drawer>
  )
}

WidgetSheet.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  footer: PropTypes.node,
  placement: PropTypes.oneOf(["bottom", "right"]),
  width: PropTypes.number,
  children: PropTypes.node.isRequired
}

WidgetSheet.defaultProps = {
  footer: null,
  placement: "bottom",
  width: 391
}

export default WidgetSheet
